var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1366_7669",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1366_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5967 3.22814C14.3861 2.96502 15.2563 3.17046 15.8447 3.75882C16.433 4.34717 16.6385 5.21744 16.3754 6.0068L15.9002 7.43218C15.4213 8.86897 14.6144 10.1745 13.5435 11.2454L7.69726 17.0917C7.18523 17.6037 6.35505 17.6037 5.84302 17.0917L2.51181 13.7605C1.99978 13.2484 1.99978 12.4183 2.51181 11.9062L8.35806 6.05999C9.42897 4.98907 10.7345 4.1822 12.1713 3.70327L13.5967 3.22814Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7793,
    cy: 7.82441,
    r: 1.25,
    transform: "rotate(45 11.7793 7.82441)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38138 8.50248C2.72749 8.15637 3.2207 8.0009 3.70272 8.08597L5.73848 8.44522L2.6463 11.5374L0.99638 9.88748L2.38138 8.50248Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.102 17.2231C11.4481 16.877 11.6036 16.3838 11.5185 15.9018L11.1593 13.866L8.06709 16.9582L9.71701 18.6081L11.102 17.2231Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 10.1816L9.42129 10.7709L4.58939 15.6028L4.00013 15.0135L8.83203 10.1816Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.c70f7df66c65b856a8a7f41786d8c4d2.svg";
export { ForwardRef as ReactComponent };